<template>
  <PageWrapper
    :action-button-href="`/monetization/org/${orgId}/links/collections`"
    :active-page="PAGE_LINKS_COLLECTIONS"
    :active-section="SECTION_MONETIZATION"
    :breadcrumbs="breadcrumbs"
    :page-name="collectionName"
    :title="`Collection - ${collectionName}`"
    action-button-text="View Collections"
  >
    <iRow :width="2700" overflow="scroll">
      <SmartFeed
        :source="useMyMonetizationLinksFeedStore"
        default-feed-layout="table"
      >
        <template #empty-state>
          <iRow vertical-align="middle" class="empty-state">
            <iIcon icon="hyperlink" size="large" />
            <iText>No Affiliate Links yet.</iText>
          </iRow>
        </template>
      </SmartFeed>
    </iRow>

    <AddAffiliateLinkToCollectionModal />
  </PageWrapper>
</template>

<script>
import { SECTION_MONETIZATION, PAGE_LINKS_COLLECTIONS } from "@/constants/nav-constants";
import PageWrapper from "@/components/PageWrapper";
import SmartFeed from "SmartFeed/components/SmartFeedV2";
import { useGeneralStore } from "%/stores/general-store";
import { mapState, mapWritableState } from "pinia";
import { useMyMonetizationLinksFeedStore } from "@/smart-feed/stores/feed/my-monetization-links-feed-store";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import AddAffiliateLinkToCollectionModal from "@/components/AddAffiliateLinkToCollectionModal.vue";

export default {
  name: "CollectionsReport",
  components: {
    SmartFeed,
    PageWrapper,
    AddAffiliateLinkToCollectionModal,
  },
  props: {
    collectionId: {
      type: Number,
      required: true,
    },
    collectionData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SECTION_MONETIZATION,
      PAGE_LINKS_COLLECTIONS,
    };
  },
  computed: {
    ...mapWritableState(useAffiliateLinkStore, [
      "activeCollectionId",
    ]),
    ...mapState(useGeneralStore, ["orgId"]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
        { url: `/monetization/org/${this.orgId}/links`, label: "My Links" },
        { url: `/monetization/org/${this.orgId}/links/collections`, label: "Collections" },
      ];
    },
    collectionName() {
      return this.collectionData.name;
    },
  },
  watch: {
    collectionId: {
      immediate: true,
      handler(newCollectionId) {
        this.activeCollectionId = Number(newCollectionId);
      },
    },
  },
  beforeUnmount() {
    this.activeCollectionId = null;
  },
  methods: {
    useMyMonetizationLinksFeedStore,
  },
};
</script>
